// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calendar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    overflow: auto;
  }
  
  .calendar {
    width: 90%;
    max-width: 1200px;
    height: 100%;
  }
  .calendar-container {
    padding: 20px;
  }
  
  .calendar {
    max-width: 900px;
    margin: 0 auto;
  }
  
  .fc-event {
    cursor: pointer;
  }
  
  .fc-event-title {
    font-weight: bold;
  }
  
  .fc-event-time {
    color: #000;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/CalenderView/mycalender.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb","sourcesContent":["\n.calendar-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80vh;\n    overflow: auto;\n  }\n  \n  .calendar {\n    width: 90%;\n    max-width: 1200px;\n    height: 100%;\n  }\n  .calendar-container {\n    padding: 20px;\n  }\n  \n  .calendar {\n    max-width: 900px;\n    margin: 0 auto;\n  }\n  \n  .fc-event {\n    cursor: pointer;\n  }\n  \n  .fc-event-title {\n    font-weight: bold;\n  }\n  \n  .fc-event-time {\n    color: #000;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
